import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const insertCityEmployee = createAsyncThunk(
  "BranchEmployee/insertCityEmployee",
  async (values, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      await axios.post(`${BaseUrl}/addCityBranchEmployee`, values, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      sweetalert({
        text: "تم التعديل بنجاح",
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      }
      return rejectWithValue(error.message);
    }
  }
);
export const fetchCitiesBranchEmployee = createAsyncThunk(
  "BranchEmployee/fetchCitiesBranchEmployee",
  async (id, thunkAPI) => {
    const {  rejectWithValue } = thunkAPI;
   
    try {
      const res = await axios.get(`${BaseUrl}/citiesBranchEmployee/${id}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const  result  = await res.data.data;
      return result;
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      }
      return rejectWithValue(error.message);
    }
  }
);
const CityEmployeeSlice = createSlice({
  name: "AddCityEmployee",
  initialState: {
    CityEmployee: [],
    CityEmployeeID: [],
    loading: false,
    loadingAdd: false,
    error: null,
  },
  reducers: {
    clearCityEmployee: (state) => {
      state.CityEmployee = [];
      state.CityEmployeeID = [];
      state.loading = false;
      state.loadingAdd = false;
      state.error = null;

    },
    setLoading: (state, action) => {
      state.loadingAdd = action.payload; // Set isLoading to the provided value 
    },
  },
  extraReducers: {
    //insert Branch Employee
    [insertCityEmployee.pending]: (state, action) => {
      state.loadingAdd = true;
      state.error = null;
    },
    [insertCityEmployee.fulfilled]: (state, action) => {
      state.CityEmployee.push(action.payload);
      state.loadingAdd = false;
    },
    [insertCityEmployee.rejected]: (state, action) => {
      state.error = action.payload;
      state.loadingAdd = false;
    },
    //Fetch Branch Employee By ID
    [fetchCitiesBranchEmployee.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchCitiesBranchEmployee.fulfilled]: (state, action) => {
      state.CityEmployeeID = action.payload;
      state.loading = false;
    },
    [fetchCitiesBranchEmployee.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export const { clearCityEmployee,setLoading } = CityEmployeeSlice.actions;
export default CityEmployeeSlice.reducer;
